import type { BrandingConfig } from '@/themes/types'

/** Applies tenant branding as CSS variables/design tokens at runtime (§14/§15/§25). */
export function applyBranding(config: BrandingConfig): void {
  const root = document.documentElement.style

  root.setProperty('--primary', config.primaryColor)
  if (config.secondaryColor) root.setProperty('--secondary', config.secondaryColor)
  if (config.radius) root.setProperty('--radius', config.radius)

  document.title = config.appName

  if (config.faviconUrl) {
    const link =
      document.querySelector<HTMLLinkElement>('link[rel="icon"]') ?? document.createElement('link')
    link.rel = 'icon'
    link.href = config.faviconUrl
    document.head.appendChild(link)
  }
}
